import {request} from '@/utils/http';

let afterSaleList = '/fronted/returns/page';
let afterSaleDetail = '/fronted/returns/detail'
let afterSaleSave = '/fronted/returns/save'
let afterSaleCancel = '/fronted/returns/cancel'
let afterSaleEdit = '/fronted/returns/update'
let afterSaleSend = '/fronted/returns/sendBack'
let afterSaleApply = '/fronted/returns/apply'
let afterSaleClose = '/fronted/returns/close'
let delivery = '/fronted/delivery/all'


export function GET_AFTERSALELIST(params){
  return request(afterSaleList,'get',params)
}
export function GET_AFTERSALEDETAIL(params){
  return request(afterSaleDetail,'get',params)
}
export function POST_AFTERSALESAVE(params){
  return request(afterSaleSave,'post',params)
}
export function POST_AFTERSALECANCEL(params){
  return request(afterSaleCancel,'post',params)
}
export function POST_AFTERSALEEDIT(params){
  return request(afterSaleEdit,'post',params)
}
export function POST_AFTERSALESEND(params){
  return request(afterSaleSend,'post',params)
}
export function POST_AFTERSALEAPPLY(params){
  return request(afterSaleApply,'post',params)
}
export function POST_AFTERSALECOLSE(params){
  return request(afterSaleClose,'post',params)
}
export function GET_DELIVERY(params){
  return request(delivery,'get',params)
}


// WEBPACK FOOTER //
// ./src/api/afterSale.api.js